import { lazy, Suspense, type ReactNode } from "react";
import { DevAuthProvider } from "./DevAuthProvider";

export const AUTH_MODE = (import.meta.env.VITE_AUTH_MODE ?? "prod").toLowerCase();
export const IS_DEV_AUTH = AUTH_MODE === "dev";

// Em dev: NÃO importar MSAL (evita erro de tenantId/clientId vazios + bundle menor).
// Em prod: lazy-load do ProdAuthProvider que inicializa MSAL com config real.
const ProdAuthProviderLazy = lazy(async () => {
  const mod = await import("./ProdAuthProvider");
  return { default: mod.ProdAuthProvider };
});

export function AuthProvider({ children }: { children: ReactNode }) {
  if (IS_DEV_AUTH) {
    return <DevAuthProvider>{children}</DevAuthProvider>;
  }
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center text-muted-foreground">
          Iniciando autenticação…
        </div>
      }
    >
      <ProdAuthProviderLazy>{children}</ProdAuthProviderLazy>
    </Suspense>
  );
}

// Em prod, msalInstance é exportado por ProdAuthProvider e re-exportado pelo
// client.ts via dynamic import (evita carregar MSAL em modo dev).
